// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\MilestoneType\ApiMilestoneType.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { CoordinationMilestoneType, CoordinationMilestoneTypeData, CoordinationMilestoneTypeOptions } from 'data/models/CoordinationMilestoneType';

// MilestoneTypeData is the class that MilestoneType serializes to/from
export interface MilestoneTypeData {
    Id : number;
	
    Coordinations : CoordinationMilestoneTypeData[] | null;
	
    DisplayOrder : number;
    Name : string;
    Nickname : string;
}

// MilestoneTypeOptions is the class which may be passed to the MilestoneType constructor to define optional initial data values
export interface MilestoneTypeOptions {
    Id : number;
	
    Coordinations? : CoordinationMilestoneTypeOptions[] | null;
	
    DisplayOrder? : number;
    Name? : string;
    Nickname? : string;
}

export class MilestoneType {
    public Id : DataSignal<number>;
	
    public Coordinations : SDataArray<CoordinationMilestoneType>;
	
    public DisplayOrder : DataSignal<number>;
    public Name : DataSignal<string>;
    public Nickname : DataSignal<string>;

    constructor();
    constructor(data : MilestoneTypeOptions);
    constructor(data: MilestoneTypeOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Coordinations = SArray<CoordinationMilestoneType>([]);
	    
        this.DisplayOrder = jsonableObservable(S.value<number>(data && data.DisplayOrder !== undefined ? data.DisplayOrder : 0));
        this.Name = jsonableObservable(S.value<string>(data && data.Name !== undefined ? data.Name : ''));
        this.Nickname = jsonableObservable(S.value<string>(data && data.Nickname !== undefined ? data.Nickname : ''));
    }

    static key(obj : MilestoneType) {
        return obj.Id();
    }
    
    static dataKey(obj : MilestoneTypeOptions) {
        return obj.Id;
    }

    static update(obj : MilestoneType, data : MilestoneTypeOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
	        
            if (data.DisplayOrder !== undefined) obj.DisplayOrder(data.DisplayOrder);
            if (data.Name !== undefined) obj.Name(data.Name);
            if (data.Nickname !== undefined) obj.Nickname(data.Nickname);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/MilestoneType.ts